import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 30 21" {...props}>
      <title>{"Skillset"}</title>
      <g stroke="#FFF" fill="none" fillRule="evenodd">
        <path d="M.5 6H29v14H.5zM10 1h9.5v5H10zM0 11.5h29.5" />
      </g>
    </svg>
  )
}

export default SvgComponent
